import { TFunction } from "react-i18next";
import { updateBootyDetailsSortingOptions } from "../../../redux/wallet/actionCreator";

type Column = any;

export const bootyDetailsColumns = (
  dispatch: AppDispatch,
  t: TFunction<"translation">
): Column[] => {
  return [
    {
      title: t("Activity name"),
      dataIndex: "activityName",
      key: "activityName",
      maxWidth: "26em",
      role: "title",
      hideIndex: true,
      isSortable: true,
      onSort: (newOrder: "ASC" | "DESC") => {
        dispatch(updateBootyDetailsSortingOptions(newOrder, "activityName"));
      },
    },
    {
      title: t("Activity"),
      dataIndex: "activityType",
      key: "activityType",
      maxWidth: "10em",
      hideIndex: true,
      isSortable: true,
      onSort: (newOrder: "ASC" | "DESC") => {
        dispatch(updateBootyDetailsSortingOptions(newOrder, "activity"));
      },
    },
    {
      title: t("Awarded on"),
      dataIndex: "attributionDate",
      key: "attributionDate",
      isSortable: true,
      onSort: (newOrder: "ASC" | "DESC") => {
        dispatch(updateBootyDetailsSortingOptions(newOrder, "attributionDate"));
      },
    },
    {
      title: t("Amount gross"),
      dataIndex: "gross",
      key: "gross",
      isSortable: true,
      role: "cta",
      hideIndex: true,
      onSort: (newOrder: "ASC" | "DESC") => {
        dispatch(updateBootyDetailsSortingOptions(newOrder, "gross"));
      },
    },
    {
      title: t("Expiration date"),
      dataIndex: "expirationDate",
      key: "expirationDate",
      hideIndex: true,
    },
  ];
};
